import {
  ComparatorSimulatorAmount,
  ComparatorSimulatorAmountDescription,
  ComparatorSimulatorAmountForm,
  ComparatorSimulatorAmountFormField,
  ComparatorSimulatorAmountHeader,
  ComparatorSimulatorAmountTitle,
} from "@tudigo-monorepo/web-tudigo-comparator";
import { UI_PROJECTS_COMPARATOR_SIMULATOR_AMOUNT_CHANGED } from "@tudigo-monorepo/web-tudigo-tracking";

import { useProjectsComparatorCustomerTracking } from "../../../../hooks/use-projects-comparator-customer-tracking";

export function ProjectsComparatorSimulatorAmount() {
  const { customerTrackComparator } = useProjectsComparatorCustomerTracking();

  return (
    <ComparatorSimulatorAmountForm
      onUpdate={(newAmount) => {
        customerTrackComparator(
          UI_PROJECTS_COMPARATOR_SIMULATOR_AMOUNT_CHANGED,
          {
            comparator_amount: newAmount,
          },
        );
      }}
    >
      <ComparatorSimulatorAmount>
        <ComparatorSimulatorAmountHeader>
          <ComparatorSimulatorAmountTitle>
            Effectuer une simulation sur ces opportunités
          </ComparatorSimulatorAmountTitle>
          <ComparatorSimulatorAmountFormField />
        </ComparatorSimulatorAmountHeader>

        <ComparatorSimulatorAmountDescription>
          Comparez et évaluez les projets que vous avez sélectionnés pour
          optimiser votre portefeuille d&apos;investissement. Accédez à une
          analyse détaillée pour chaque option, vous permettant de peser les
          avantages et les risques associés de manière éclairée
        </ComparatorSimulatorAmountDescription>
        <ComparatorSimulatorAmountDescription>
          Le potentiel de rendement est proportionnel aux risques de perte en
          capital et d&apos;illiquidité. Les performances des sociétés financées
          ne préjugent pas des performances futures. Simulation hors frais
          Tudigo et brut d&apos;impôts.
        </ComparatorSimulatorAmountDescription>
      </ComparatorSimulatorAmount>
    </ComparatorSimulatorAmountForm>
  );
}
